// i18n
import './locales/i18n';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
// material
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// redux
import { store } from './redux/store';
// contexts
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
//
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles.css';

const rootContainer = document.getElementById('root');
const root = createRoot(rootContainer!);

root.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      {/* @ts-ignore */} {/* ignore needed because in react 18.x children prop was removed */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {/* <SettingsProvider> */}
          <CollapseDrawerProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </CollapseDrawerProvider>
          {/* </SettingsProvider> */}
        </LocalizationProvider>
    </ReduxProvider>
  </HelmetProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();